import { useState, useEffect } from 'react';
import './DashboardPages.css';
import { usersApi } from '../api/users';
import defaultUserPhoto from '../assets/Assemblie_DefaultUserIcon.png';
import DashboardLayout from '../components/DashboardLayout';

function formatPhoneNumber(phoneNumber) {
	// Remove all non-numeric characters
	const cleaned = phoneNumber?.replace(/\D/g, '');

	// Check if we have a valid number
	if (!cleaned || cleaned.length !== 10) return phoneNumber;

	// Format as (XXX) XXX-XXXX
	return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
		6
	)}`;
}

function DashboardPeople() {
	const [users, setUsers] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState('');
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [userToDelete, setUserToDelete] = useState(null);

	useEffect(() => {
		const fetchUsers = async () => {
			try {
				const orgId = '1'; // You'll need to get this from your auth context or props
				const data = await usersApi.getAll(orgId);
				setUsers(data.users);
			} catch (error) {
				console.error('Error fetching users:', error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchUsers();
	}, []);

	const handleDelete = (user) => {
		setUserToDelete(user);
		setIsDeleteModalOpen(true);
	};

	const confirmDelete = async () => {
		try {
			await usersApi.removeFromOrganization('1', userToDelete.id); // Replace '1' with actual orgId
			setUsers(users.filter((user) => user.id !== userToDelete.id));
			setIsDeleteModalOpen(false);
			setUserToDelete(null);
		} catch (err) {
			setError('Failed to remove user from organization');
			console.error(err);
		}
	};

	const cancelDelete = () => {
		setIsDeleteModalOpen(false);
		setUserToDelete(null);
	};

	return (
		<DashboardLayout>
			<div className='dashboard-page'>
				<h1>People</h1>
				<div className='content-section'>
					<p>Manage church members and contacts here.</p>
					{error && <div className='error-message'>{error}</div>}

					{isLoading ? (
						<p>Loading users...</p>
					) : (
						<div className='table-responsive'>
							<table className='users-table'>
								<thead>
									<tr>
										<th>Photo</th>
										<th>Name</th>
										<th>Email</th>
										<th>Phone Number</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{users.map((user) => (
										<tr key={user.id}>
											<td>
												<img
													src={
														user.userPhoto ||
														defaultUserPhoto
													}
													alt={`${user.firstName} ${user.lastName}`}
													className='user-avatar-people'
												/>
											</td>
											<td className='name-container'>
												<span className='user-name'>
													{user.firstName}
												</span>
												<span className='user-name'>
													{user.lastName}
												</span>
											</td>
											<td className='user-email'>
												{user.email}
											</td>
											<td className='user-phone'>
												{formatPhoneNumber(
													user.phoneNumber
												)}
											</td>
											<td>
												<button
													onClick={() =>
														handleDelete(user)
													}
													className='delete-btn user-action'>
													Remove
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}

					{isDeleteModalOpen && (
						<div className='modal'>
							<div className='modal-content delete-modal'>
								<div className='modal-header'>
									<h2>Remove User</h2>
								</div>
								<div className='modal-body'>
									<p>
										Are you sure you want to remove{' '}
										{userToDelete?.firstName}{' '}
										{userToDelete?.lastName} from the
										organization?
									</p>
									<p className='delete-warning'>
										This action cannot be undone.
									</p>
								</div>
								<div className='modal-footer'>
									<button
										onClick={cancelDelete}
										className='secondary-button'>
										Cancel
									</button>
									<button
										onClick={confirmDelete}
										className='primary-button modal-button-danger'>
										Remove
									</button>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</DashboardLayout>
	);
}

export default DashboardPeople;
